import React from "react";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";
import { isMobile } from "react-device-detect";
import styled from "styled-components";

const SuspensionUI = () => {
  const model = useCustomizerStore((state) => state.model);
  const DisplayMode = useTransitionStore((state) => state.DisplayMode);
  const SelectedSuspensionAnimation = useTransitionStore(
    (s) => s.SelectedSuspensionAnimation
  );
  const setSelectedSuspensionAnimation = useTransitionStore(
    (s) => s.setSelectedSuspensionAnimation
  );
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);

  return (
    <>
      {model === 2 && SuspensionMode && (
        <Container isMobile={isMobile}>
          <div className="title">SELECT SUSPENSION TYPE</div>
          <div className="radio-group">
            <div className="radio">
              <input
                type="radio"
                name="standard"
                id="standard"
                checked={SelectedSuspensionAnimation == "standard"}
                onChange={() => setSelectedSuspensionAnimation("standard")}
              />
              <label className="radio-label" htmlFor="standard">
                Standard
              </label>
            </div>
            <div className="radio">
              <input
                type="radio"
                name="comfort"
                id="comfort"
                checked={SelectedSuspensionAnimation == "comfort"}
                onChange={() => setSelectedSuspensionAnimation("comfort")}
              />
              <label className="radio-label" htmlFor="comfort">
                Comfort
              </label>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

export const Container = styled.div`
  margin-right: ${({ isMobile }) => (isMobile ? "0" : ".5rem")};
  margin-left: ${({ isMobile }) => (isMobile ? "0" : "18px")};
  position: ${({ isMobile }) => (isMobile ? "static" : "absolute")};
  right: ${({ isMobile }) => (isMobile ? null : "4rem")};
  bottom: ${({ isMobile }) => (isMobile ? null : "40px")};
  display: block;
  z-index: 998;
  color: white;

  .title {
    margin-bottom: 10px;
  }

  .radio-group {
    display: flex;
    gap: 30px;
    justify-content: ${({ isMobile }) =>
      isMobile ? "flex-start" : "flex-end"};

    .radio {
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        position: absolute;
        opacity: 0;
        width: 100%;
        pointer-events: none;
        cursor: pointer;

        + .radio-label {
          pointer-events: auto;
          cursor: pointer;

          &:before {
            content: "";
            background: #000;
            border-radius: 100%;
            border: 2px solid #fff;
            display: inline-block;
            width: 20px;
            height: 20px;
            position: relative;
            margin-right: 1em;
            vertical-align: top;
            cursor: pointer;
            text-align: center;
            transition: all 0.3s ease-in-out;
          }
        }

        &:checked {
          + .radio-label {
            &:before {
              background: #fff;
              box-shadow: inset 0 0 0 4px #000;
            }
          }
        }
        + .radio-label {
          &:empty {
            &:before {
              margin-right: 0;
            }
          }
        }
      }

      &:first-child {
        input {
          margin-left: ${({ isMobile }) => (isMobile ? 0 : null)};
        }
      }
    }
  }
`;

export default SuspensionUI;
